export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14319.7c59a335.jpg";